import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import AWS from 'aws-sdk';
import './Authentication.css';
import { useCustomContext } from '../CustomComponents/CustomComponents';
import { FaRegEye, FaRegEyeSlash } from 'react-icons/fa6';
import UserPool from '../../UserPool';
import { jwtDecode } from 'jwt-decode';
import { insertLog } from '../Logs/InsertLog';


// AWS.config.update({
//     // accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
//     // secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
//     region: process.env.REACT_APP_AWS_REGION
// });

// const cognitoISP = new AWS.CognitoIdentityServiceProvider();

function SignUp({ onLogin }) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [emailErrorMessage, setEmailErrorMessage] = useState('');
    const [passwordErrorMessage, setPasswordErrorMessage] = useState('');
    const [fullName, setFullName] = useState('');
    const [fullNameErrorMessage, setFullNameErrorMessage] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const { showAlert, hud, stopHudRotation } = useCustomContext();

    const location = useLocation();
    const navigate = useNavigate();

    const handleFullNameChange = (e) => {
        const value = e.target.value;
        setFullName(value);
        validateFullName(value);
    };

    const handleEmailChange = (e) => {
        const value = e.target.value.replace(/\s/g, "");
        setEmail(value);
        validateEmail(value);
    };
    const handlePasswordChange = (e) => {
        const value = e.target.value;
        setPassword(value);
        validatePassword(value);
    };

    const validateFullName = (value) => {
        const isValidLength = value.length > 0;
        if (!isValidLength) {
            setFullNameErrorMessage('Enter your full name.');
        } else {
            setFullNameErrorMessage('');
        }
    };

    const validateEmail = (value) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const isValidEmail = emailRegex.test(value);
        if (!isValidEmail) {
            setEmailErrorMessage('Enter a valid email address.');
        } else {
            setEmailErrorMessage('');
        }
    };



    const passwordRegex =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\^$*.\[\]{}()?"!@#%&\/\\,><':;|_~`+= -])[A-Za-z\d\^$*.\[\]{}()?"!@#%&\/\\,><':;|_~`+= -]{8,}$/;

    const validatePassword = (value) => {
        if (!value) {
            setPasswordErrorMessage("Password is required");
        } else if (value !== value.trim()) {
            setPasswordErrorMessage(
                "Password cannot start or end with a space"
            );
        } else if (/\s{2,}/.test(value)) {
            setPasswordErrorMessage(
                "Password cannot contain multiple consecutive spaces"
            );
        } else if (!passwordRegex.test(value)) {
            setPasswordErrorMessage(
                "Password must be at least 8 characters and include uppercase, lowercase, number, and special character"
            );
        } else {
            setPasswordErrorMessage("");
        }
    };
    const toggleShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleGoogleLogin = () => {
        const clientId = process.env.REACT_APP_COGNITO_CLIENTID;
        const domain = 'us-east-1z0mtkhk91.auth.us-east-1.amazoncognito.com';
        const redirectUri = '';
        const responseType = 'code';
        const scope = 'openid profile email';

        const queryParams = new URLSearchParams({
            identity_provider: 'Google',
            redirect_uri: redirectUri,
            response_type: responseType,
            client_id: clientId,
            scope: scope,
            prompt: 'select_account'
        });

        window.location.href = `https://${domain}/oauth2/authorize?${queryParams.toString()}`;

    };

    const handleKeyDown = (e) => {
        if (e.key === " ") {
            e.preventDefault(); // block space key
        }
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        // Clear previous error messages
        setEmailErrorMessage('');
        setPasswordErrorMessage('');
        setFullNameErrorMessage('');

        // Validate fields
        validateFullName(fullName);
        validateEmail(email);
        validatePassword(password);

        // Check for empty fields
        if (!fullName) {
            setFullNameErrorMessage('Enter your full name.');
        }
        if (!email) {
            setEmailErrorMessage('Enter your email address.');
        }
        if (!password) {
            setPasswordErrorMessage('Enter your password.');
        }

        // Exit early if any field is empty or has errors
        let hasError = false;

        if (!fullName) {
            setFullNameErrorMessage('Enter your full name.');
            hasError = true;
        }

        if (!email) {
            setEmailErrorMessage('Enter your email address.');
            hasError = true;
        }

        if (!password) {
            setPasswordErrorMessage('Password is required');
            hasError = true;
        }

        if (
            password &&
            (
                password !== password.trim() ||
                /\s{2,}/.test(password) ||
                !passwordRegex.test(password)
            )
        ) {
            hasError = true;
        }

        if (hasError) return;

        console.log("Password:", password.trim())

        hud("Please Wait...");

        // // Step 1: Check if user already exists in Cognito
        // try {
        //     const response = await cognitoISP.listUsers({
        //         UserPoolId: process.env.REACT_APP_COGNITO_USERPOOLID,
        //         Filter: `email = "${email}"`,
        //     }).promise();

        //     const existingUsers = response.Users || [];
        //     if (existingUsers.length > 0) {
        //         const existingUser = existingUsers[0];

        //         if (existingUser.UserStatus === 'EXTERNAL_PROVIDER') {
        //             stopHudRotation();
        //             showAlert("User already exists with Google Provider.", [
        //                 {
        //                     label: 'Sign in with Google',
        //                     onClick: () => {
        //                         handleGoogleLogin();
        //                     },
        //                     color: 'var(--buttonColor)',
        //                 },
        //                 {
        //                     label: 'Cancel',
        //                     onClick: () => {
        //                         navigate('/');
        //                     },
        //                     color: 'var(--error)',
        //                 },
        //             ]);
        //             return;
        //         } else {
        //             stopHudRotation();
        //             showAlert("User already exists with this email address.", [
        //                 {
        //                     label: 'OK',
        //                     onClick: () => { },
        //                     color: 'var(--buttonColor)',
        //                 },
        //             ]);
        //             return;
        //         }
        //     }
        // } catch (error) {
        //     console.error("Error checking existing user:", error);
        //     stopHudRotation();
        //     showAlert("Something went wrong. Please try again.", [
        //         {
        //             label: 'OK',
        //             onClick: () => { },
        //             color: 'var(--buttonColor)',
        //         },
        //     ]);
        //     return;
        // }

        // Step 2: If not exists, proceed with registration
        const attributes = [
            {
                Name: 'custom:empInfo',
                Value: JSON.stringify({
                    name: fullName.trim(),
                    accessLevel: 3,
                    isEmployeeApproved: false,
                    isEmployeeActive: false
                })
            }
        ];

        UserPool.signUp(email, password.trim(), attributes, null, (err, data) => {
            stopHudRotation();
            if (err) {
                showAlert(err.message, [
                    {
                        label: 'Ok',
                        onClick: () => { },
                        color: 'var(--buttonColor)',
                    },
                ]);
            } else {
                showAlert('Verification code sent to your registered email address.', [
                    {
                        label: 'Ok',
                        onClick: () => {
                            setEmail('');
                            setPassword('');
                            setFullName('');
                            navigate('/VerifyEmail', { state: { email } });
                        },
                        color: 'var(--buttonColor)',
                    },
                ]);
            }
        });
    };


    return (
        <div className='container d-flex flex-column align-items-center login-hub'>
            <span className="heading-span mb-2">{process.env.REACT_APP_NAME}</span>
            <span className='font-weight-bold mb-3 logo'>
                Welcome to the {process.env.REACT_APP_NAME}. Please sign up for your account.
            </span>
            <div className='input-container mb-3 w-100'>
                <div className='d-flex justify-content-center w-100'>
                    <form onSubmit={handleSubmit} className='form-container'>
                        <div className='form-group mb-3'>
                            <input
                                className={`form-control ${fullNameErrorMessage ? 'is-invalid' : fullName ? 'is-valid' : ''} inputs`}
                                type='text'
                                placeholder='Full Name'
                                value={fullName}
                                onChange={handleFullNameChange}
                            />
                            {fullNameErrorMessage && <div className='invalid-feedback error-message'>{fullNameErrorMessage}</div>}
                        </div>
                        <div className='form-group mb-3'>
                            <input
                                className={`form-control ${emailErrorMessage ? 'is-invalid' : email ? 'is-valid' : ''} inputs`}
                                type='email'
                                placeholder='Email'
                                value={email}
                                onChange={handleEmailChange}
                                onKeyDown={handleKeyDown}
                            />
                            {emailErrorMessage && <div className='invalid-feedback error-message'>{emailErrorMessage}</div>}
                        </div>
                        <div className='form-group'>
                            <div className='password-container'>
                                <input
                                    className={`form-control ${passwordErrorMessage ? 'is-invalid' : password ? 'is-valid' : ''} inputs`}
                                    type={showPassword ? 'text' : 'password'}
                                    placeholder='Password'
                                    value={password}
                                    onChange={handlePasswordChange}
                                /><span
                                    className='password-toggle-icon'
                                    onClick={toggleShowPassword}
                                    style={{ right: passwordErrorMessage ? '40px' : '10px',
                                        top: '8px'
                                    }}
                                >
                                    {showPassword ? <FaRegEye /> : <FaRegEyeSlash />}
                                </span>

                                {passwordErrorMessage && <div className='invalid-feedback error-message'>{passwordErrorMessage}</div>}
                            </div>
                        </div>
                        <button className='btn btn-primary submit btn-block mt-4 submit-button' type='submit'>
                            Create Account
                        </button>
                    </form>
                </div>
                <div className="form-group mb-3 text-center" style={{ paddingTop: '10px' }}>
                    <p>
                        Already have an account?{' '}
                        <Link
                            to="/"
                            className="text-decoration-underline custom-link2"
                        >
                            Sign In
                        </Link>
                    </p>
                </div>
            </div>
        </div>
    );
}

export default SignUp;